var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMixCardThumbsUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6225_20027)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.8097 8.83671C25.5613 8.55515 25.2558 8.32968 24.9135 8.17527C24.5712 8.02086 24.2 7.94104 23.8244 7.94112H17.648V6.17641C17.648 5.00634 17.1832 3.88419 16.3558 3.05682C15.5284 2.22946 14.4063 1.76465 13.2362 1.76465C13.0723 1.76453 12.9116 1.81008 12.7721 1.89619C12.6326 1.98229 12.5199 2.10556 12.4465 2.25215L8.2796 10.5882H3.53033C3.0623 10.5882 2.61344 10.7741 2.2825 11.105C1.95155 11.436 1.76563 11.8849 1.76562 12.3529V22.0588C1.76563 22.5268 1.95155 22.9757 2.2825 23.3066C2.61344 23.6376 3.0623 23.8235 3.53033 23.8235H22.5009C23.1458 23.8237 23.7686 23.5885 24.2524 23.162C24.7361 22.7355 25.0475 22.1471 25.1281 21.5073L26.4517 10.9191C26.4986 10.5463 26.4656 10.1678 26.3549 9.80877C26.2442 9.44973 26.0584 9.11837 25.8097 8.83671ZM3.53033 12.3529H7.9421V22.0588H3.53033V12.3529Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6225_20027"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28.2353,
    height: 28.2353,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMixCardThumbsUp);
export default __webpack_public_path__ + "static/media/mix-card-thumbs-up.f60325efa60f8921a5ee4744f13600e8.svg";
export { ForwardRef as ReactComponent };